import type {
  Variables,
  VariablesType,
} from '@web-platform/shared-universal-types/src/network/types';

export const formatStrevdaVariables = (variables: Variables) => {
  let userFlightDetails: VariablesType;

  // cabinClass can be in userSearch or flightSearch depending on the context
  if (variables && 'userSearch' in variables && typeof variables.userSearch === 'object') {
    userFlightDetails = variables.userSearch;
  } else if (
    variables &&
    'flightSearch' in variables &&
    typeof variables.flightSearch === 'object'
  ) {
    userFlightDetails = variables.flightSearch;
  } else {
    userFlightDetails = null;
  }

  // format cabinClass from PREMIUM_ECONOMY to PREMIUMECONOMY
  const getCabinClass = () => {
    let updatedCabinClass;

    if (userFlightDetails && 'cabinClass' in userFlightDetails) {
      updatedCabinClass =
        userFlightDetails.cabinClass === 'PREMIUM_ECONOMY'
          ? 'PREMIUMECONOMY'
          : userFlightDetails.cabinClass;
    } else {
      updatedCabinClass = null;
    }

    return updatedCabinClass;
  };

  const cabinClass = getCabinClass();

  let updatedVariables: Variables;

  // reconstruct variables with updated cabinClass
  if (cabinClass && userFlightDetails && 'userSearch' in variables) {
    updatedVariables = {
      ...variables,
      userSearch: { ...userFlightDetails, cabinClass },
    };
  } else if (cabinClass && userFlightDetails && 'flightSearch' in variables) {
    updatedVariables = {
      ...variables,
      flightSearch: { ...userFlightDetails, cabinClass },
    };
  } else {
    updatedVariables = { ...variables };
  }

  return updatedVariables;
};
